export function parseMarkdownRow(line: string): string[] {
  const trimmed = line.trim();
  const withoutLeadingPipe = trimmed.startsWith("|") ? trimmed.slice(1) : trimmed;
  const withoutOuterPipes = withoutLeadingPipe.endsWith("|")
    ? withoutLeadingPipe.slice(0, -1)
    : withoutLeadingPipe;

  return withoutOuterPipes.split("|").map((cell) => cell.trim());
}

export function alignMarkdownRow(row: string[], columnCount: number): string[] {
  if (row.length >= columnCount) {
    return row.slice(0, columnCount);
  }

  return [...row, ...Array<string>(columnCount - row.length).fill("")];
}
